/* import { TYPE } from 'app/config/pad_prescription_suggestion_scheduling';
import { CALENDAR_TYPE } from 'app/config/calendar_type';
import { isEmpty } from 'lodash'; */
const TEMPLATE_NAME = 'RESCHEDULE_PAD';
/* function objectToState(calendarType, type, suggestionSchedulingList) {
  let sugestionScheduling = {
    prescriptionContentId: null,
    calendarType,
    suggestionType: type,
    firstApplicationDate: null,
    firstApplicationTime: null,
    applicationTimes: [],
    perDayPerShifts: [],
    daysOfWeek: [],
    perWeekPerShift: null,
    perWeekSpecificTime: null,
    perMonthSpecificTime: null,
    perMonthSpecificTimeDates: [],
    perMonthPerShiftDates: [],
    perMonthPerShift: null,
    instructions: null
  };
  if (calendarType === CALENDAR_TYPE.EVERY) {
    sugestionScheduling.firstApplicationDate = suggestionSchedulingList[0].applicationDate;
    sugestionScheduling.firstApplicationTime = suggestionSchedulingList[0].applicationTime;
  } else if (calendarType === CALENDAR_TYPE.PER_SHIFT) {
    sugestionScheduling.perDayPerShifts = suggestionSchedulingList.map(item => item.shift);
    sugestionScheduling.applicationTimes = suggestionSchedulingList.map(
      item => item.applicationTime
    );
  } else if (calendarType === CALENDAR_TYPE.TIMES_PER) {
    if (type === TYPE.DAY_HOUR || type === TYPE.DAY_SHIFT) {
      sugestionScheduling.applicationTimes = suggestionSchedulingList.map(
        item => item.applicationTime
      );
      sugestionScheduling.perDayPerShifts = suggestionSchedulingList.map(item => item.shift);
    } else if (type === TYPE.WEEK_HOUR || type === TYPE.WEEK_SHIFT) {
      sugestionScheduling.daysOfWeek = suggestionSchedulingList.map(item => item.dayOfWeek);
      sugestionScheduling.perWeekSpecificTime = suggestionSchedulingList.map(
        item => item.applicationTime
      );
      sugestionScheduling.perWeekPerShift = suggestionSchedulingList.map(item => item.shift);
    } else if (type === TYPE.MONTH_HOUR || type === TYPE.MONTH_SHIFT) {
      sugestionScheduling.perMonthSpecificTime = suggestionSchedulingList.map(
        item => item.applicationTime
      );
      sugestionScheduling.perMonthSpecificTimeDates = suggestionSchedulingList.map(
        item => item.applicationDate
      );
      sugestionScheduling.perMonthPerShiftDates = suggestionSchedulingList.map(
        item => item.applicationDate
      );
      sugestionScheduling.perMonthPerShift = suggestionSchedulingList.map(item => item.shift);
    }
  }
  return sugestionScheduling;
} */
/* function buildPrescription(prescriptionContent) {
  this._sugestionScheduling = {};

  const { prescriptionContentSuggestionSchedulingList, calendarType, id } = prescriptionContent;
  if (!isEmpty(prescriptionContentSuggestionSchedulingList)) {
    const { type } = prescriptionContentSuggestionSchedulingList[0];

    this._sugestionScheduling = objectToState(
      calendarType,
      type,
      prescriptionContentSuggestionSchedulingList
    );
    this._sugestionScheduling.prescriptionContentId = id;
  }
  this._sugestionScheduling = {
    sugestionScheduling: { ...this._sugestionScheduling },
    ...prescriptionContent
  };

  this.getPrescription = function () {
    return this._sugestionScheduling;
  };
} */
const initialState = () => ({
  errors: [],
  loading: false,
  pad: {},
  // prescriptionContents: [],
  loadedData: [],
  submitData: []
});

/* const preparePrescriptioReschedule = prescriptionContents => {
  return prescriptionContents.map(prescriptionContent => {
    return new buildPrescription(prescriptionContent).getPrescription();
  });
}; */

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { pad, prescriptionContents } = action.payload;

      return {
        ...state,
        loading: false,
        pad,
        // prescriptionContents,
        loadedData: prescriptionContents,
        submitData: []
      };
    }

    case `${TEMPLATE_NAME}_ADD_SUBMIT`: {
      const nPrescriptionContent = action.payload;

      const nPrescriptionContentId = nPrescriptionContent.prescriptionContentId;

      const cPrescriptionContent = state.submitData.find(
        pContent => pContent.prescriptionContentId === nPrescriptionContentId
      );

      let submitData = [...state.submitData];

      if (!cPrescriptionContent) {
        // add submit
        submitData.push(nPrescriptionContent);
      } else {
        // replace submit
        submitData = [...submitData].map(pContent => {
          const cPrescriptionContentId = pContent.prescriptionContentId;
          const nPrescriptionContentId = nPrescriptionContent.prescriptionContentId;
          const itemToBeReplaced = cPrescriptionContentId === nPrescriptionContentId;

          if (itemToBeReplaced) {
            return nPrescriptionContent;
          }

          return pContent;
        });
      }

      return {
        ...state,
        submitData
      };
    }

    case `${TEMPLATE_NAME}_REMOVE_SUBMIT`: {
      const nPrescriptionContent = action.payload;

      const submitData = state.submitData.filter(prescriptionContent => {
        const cPrescriptionContentId = prescriptionContent.prescriptionContentId;
        const nPrescriptionContentId = nPrescriptionContent.prescriptionContentId;

        return cPrescriptionContentId !== nPrescriptionContentId;
      });

      return {
        ...state,
        submitData
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
